import React from "react";
import { ContainerComponent, wrap } from 'AppReact';
import controller from './controller';
import internalState from './internalState';
import { ColumnWrapper, Mt1, Mt2 } from 'wrappers';
import { TextButton } from 'molecules';
import { PrimaryTextSmBold, NoteText, Icon, SecondaryTextXs400 } from 'atoms';
import { getEventData } from 'utils';
import { GlassesEmojiSvg, ClockSvg, } from 'components/icons';
import NoteMediaFiles from '../noteMediaFiles';
import { getNoteText } from 'utils';
import { FlexCenterWrapper, Mr1, Mr2 } from 'wrappers';
import { convertSecondsToTime } from "utils/dateAndTimeUtils";

export const definition = {
  name: 'OrderEvent',
  controller,
  initialProps: ({ order_event, totalTimeTracked }) => ({ order_event, totalTimeTracked }),
  props: internalState,
  renderIf: ({ order_event }) => !!order_event,
  elements: [
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ }) => GlassesEmojiSvg({ width: 76, height: 76 })
    },
    {
      component: wrap(PrimaryTextSmBold, Mt2),
      name: 'CompleteText',
      displayValue: ({ }) => 'WORK ORDER COMPLETED'
    },
    {
      wrapper: wrap(FlexCenterWrapper, Mt1),
      name: "Wrapper",
      elements: [
        {
          component: wrap(SecondaryTextXs400, Mr2),
          name: 'By',
          displayValue: ({ order_event }) => `${getEventData(order_event).by ?? ''} ${getEventData(order_event).timeStamp ?? ''}`
        },
        {
          wrapper: FlexCenterWrapper,
          name: "TimeWrapper",
          renderIf: ({ totalTimeTracked }) => totalTimeTracked > 0,
          elements: [
            {
              component: wrap(Icon, Mr1),
              name: 'Icon',
              displayValue: ({ }) => ClockSvg({ color: "#566F75", height: 12, width: 12 }),
            },
            {
              component: SecondaryTextXs400,
              name: 'TimeTracked',
              displayValue: ({ totalTimeTracked }) => `${convertSecondsToTime(totalTimeTracked)}`
            },
          ],
        },
      ]
    },
    {
      component: wrap(NoteMediaFiles, Mt2),
      name: 'Image',
      renderIf: ({ order_event, isOpen }) => !!getEventData(order_event).attachments && isOpen,
      bindings: ({ order_event }) => ({
        files: getEventData(order_event).attachments,
        popup: { text: 'Click to see full screen', position: 'top' }
      })
    },
    {
      component: wrap(NoteText, Mt2),
      name: 'Creator',
      renderIf: ({ isOpen }) => isOpen,
      displayValue: ({ order_event, translated, translation }) => {
        if (translated) {
          return getNoteText(translation)
        } else {
          return getNoteText(getEventData(order_event).description ?? '')
        }
      }
    },
    {
      component: wrap(TextButton, Mt2),
      name: 'TranslateButton',
      renderIf: ({ order_event, isOpen }) => !!order_event.description && isOpen,
      bindings: ({ translated, order_event, translation }) => ({ mobileSmall: true, title: translated ? 'Translate' : 'Traducir', translated, order_event, translation })
    },
    {
      component: wrap(TextButton, Mt2),
      name: 'Button',
      renderIf: ({ order_event }) => getEventData(order_event).attachments?.length > 0 || getEventData(order_event).description,
      bindings: ({ isOpen }) => ({ mobileSmall: true, isOpen, title: isOpen ? 'See less' : 'See more' })
    },
  ]
};

export default wrap(ContainerComponent(definition), ColumnWrapper);
